import { authClient } from "@/lib/authClient";
import { RouteTable } from "@/lib/routes";
import { Loading } from "@/pages/Loading";
import { Navigate, useLocation } from "react-router";

export const ProtectedRoute = ({ children }: React.PropsWithChildren) => {
  const { data: session, isPending, isRefetching } = authClient.useSession();
  const location = useLocation();

  if (isPending) return <Loading />;

  if (!isPending && !isRefetching && !session) {
    return <Navigate to={RouteTable.login()} replace />;
  }

  if (session?.user?.requiresPasswordChange && location.pathname !== RouteTable.setPassword.path) {
    return <Navigate to={RouteTable.setPassword({ callbackUrl: location.pathname })} replace />;
  }

  return <>{children}</>;
};
